export const quiz = {
  "appLocale": {
    "landingHeaderText": "Node.js Assessment (<questionLength> Questions)",
    "question": "Question",
    "startQuizBtn": "Start Assessment",
    "resultFilterAll": "All",
    "resultFilterCorrect": "Correct",
    "resultFilterIncorrect": "Incorrect",
    "prevQuestionBtn": "Prev",
    "nextQuestionBtn": "Next",
    "resultPageHeaderText": "You completed the assessment. You got <correctIndexLength> out of <questionLength> correct."
  },

  "quizTitle": "Node JS",
  "quizSynopsis": "This assessment evaluates your understanding of Node.js fundamentals, modules, events, buffers, streams, NPM, file system, HTTP server, and asynchronous programming.",
  "nrOfQuestions": "50",
  "questions": [
    {
      "question": "What is Node.js built on?",
      "questionType": "text",
      "answerSelectionType": "single",
      "answers": [
        "Chrome V8 JavaScript engine",
        "Mozilla SpiderMonkey engine",
        "Java Virtual Machine",
        "Android WebKit engine"
      ],
      "correctAnswer": "1",
      "messageForCorrectAnswer": "Correct.",
      "messageForIncorrectAnswer": "Incorrect.",
      "explanation": "Node.js is built on the Chrome V8 JavaScript engine.",
      "point": "2"
    },
    {
      "question": "Node.js is primarily used for:",
      "questionType": "text",
      "answerSelectionType": "single",
      "answers": [
        "Backend development",
        "Mobile app UI",
        "Graphic rendering",
        "Database storage"
      ],
      "correctAnswer": "1",
      "messageForCorrectAnswer": "Correct.",
      "messageForIncorrectAnswer": "Incorrect.",
      "explanation": "Node.js is mainly used for building backend/server-side applications.",
      "point": "2"
    },
    {
      "question": "Which of the following describe Node.js?",
      "questionType": "text",
      "answerSelectionType": "multiple",
      "answers": [
        "Open-source",
        "Cross-platform",
        "Server-side JavaScript",
        "Database engine"
      ],
      "correctAnswer": [1, 2, 3],
      "messageForCorrectAnswer": "Correct.",
      "messageForIncorrectAnswer": "Incorrect.",
      "explanation": "Node.js is open-source, cross-platform, and allows server-side JavaScript execution.",
      "point": "2"
    },
    {
      "question": "What does NPM stand for?",
      "questionType": "text",
      "answerSelectionType": "single",
      "answers": [
        "Node Package Manager",
        "Network Package Manager",
        "Node Program Manager",
        "New Project Manager"
      ],
      "correctAnswer": "1",
      "messageForCorrectAnswer": "Correct.",
      "messageForIncorrectAnswer": "Incorrect.",
      "explanation": "NPM stands for Node Package Manager and is used to manage Node.js packages.",
      "point": "2"
    },
    {
      "question": "Which file contains metadata for a Node.js project?",
      "questionType": "text",
      "answerSelectionType": "single",
      "answers": [
        "package-info.json",
        "node.json",
        "project.json",
        "package.json"
      ],
      "correctAnswer": "4",
      "messageForCorrectAnswer": "Correct.",
      "messageForIncorrectAnswer": "Incorrect.",
      "explanation": "package.json contains project metadata, scripts, and dependencies for Node.js projects.",
      "point": "2"
    },
    {
      "question": "Which command initializes a Node.js project?",
      "questionType": "text",
      "answerSelectionType": "single",
      "answers": [
        "npm init",
        "node init",
        "npm start",
        "npm create"
      ],
      "correctAnswer": "1",
      "messageForCorrectAnswer": "Correct.",
      "messageForIncorrectAnswer": "Incorrect.",
      "explanation": "npm init initializes a new Node.js project and creates package.json.",
      "point": "2"
    },
    {
      "question": "Node.js supports which types of modules?",
      "questionType": "text",
      "answerSelectionType": "multiple",
      "answers": [
        "Local modules",
        "Built-in modules",
        "Third-party modules",
        "Java modules"
      ],
      "correctAnswer": [1, 2, 3],
      "messageForCorrectAnswer": "Correct.",
      "messageForIncorrectAnswer": "Incorrect.",
      "explanation": "Node.js supports local, built-in, and third-party modules.",
      "point": "2"
    },
    {
      "question": "Which module is used to work with file paths?",
      "questionType": "text",
      "answerSelectionType": "single",
      "answers": [
        "path",
        "fs",
        "url",
        "http"
      ],
      "correctAnswer": "1",
      "messageForCorrectAnswer": "Correct.",
      "messageForIncorrectAnswer": "Incorrect.",
      "explanation": "The 'path' module provides utilities for handling file and directory paths.",
      "point": "2"
    },
    {
      "question": "Which module is used to handle file operations?",
      "questionType": "text",
      "answerSelectionType": "single",
      "answers": [
        "http",
        "path",
        "fs",
        "os"
      ],
      "correctAnswer": "3",
      "messageForCorrectAnswer": "Correct.",
      "messageForIncorrectAnswer": "Incorrect.",
      "explanation": "The 'fs' module is used for file system operations like reading and writing files.",
      "point": "2"
    },
    {
      "question": "Which module creates an HTTP server in Node.js?",
      "questionType": "text",
      "answerSelectionType": "single",
      "answers": [
        "http",
        "server",
        "net",
        "web"
      ],
      "correctAnswer": "1",
      "messageForCorrectAnswer": "Correct.",
      "messageForIncorrectAnswer": "Incorrect.",
      "explanation": "The 'http' module is used to create HTTP servers in Node.js.",
      "point": "2"
    },
    {
      "question": "Which method creates a Node.js server?",
      "questionType": "text",
      "answerSelectionType": "single",
      "answers": [
        "http.run()",
        "http.listen()",
        "http.createServer()",
        "server()"
      ],
      "correctAnswer": "3",
      "messageForCorrectAnswer": "Correct.",
      "messageForIncorrectAnswer": "Incorrect.",
      "explanation": "http.createServer() creates a new HTTP server.",
      "point": "2"
    },
    {
      "question": "Which of the following are Node.js built-in modules?",
      "questionType": "text",
      "answerSelectionType": "multiple",
      "answers": [
        "fs",
        "events",
        "http",
        "jQuery"
      ],
      "correctAnswer": [1, 2, 3],
      "messageForCorrectAnswer": "Correct.",
      "messageForIncorrectAnswer": "Incorrect.",
      "explanation": "fs, events, and http are built-in Node.js modules.",
      "point": "2"
    },
    {
      "question": "Node.js runs on which architecture?",
      "questionType": "text",
      "answerSelectionType": "single",
      "answers": [
        "Single-threaded event loop",
        "Multi-threaded synchronous",
        "Single-threaded blocking",
        "Multi-threaded blocking"
      ],
      "correctAnswer": "1",
      "messageForCorrectAnswer": "Correct.",
      "messageForIncorrectAnswer": "Incorrect.",
      "explanation": "Node.js uses a single-threaded event loop architecture.",
      "point": "2"
    },
    {
      "question": "What type of programming model does Node.js use?",
      "questionType": "text",
      "answerSelectionType": "single",
      "answers": [
        "Synchronous",
        "Blocking",
        "Asynchronous non-blocking",
        "Static procedural"
      ],
      "correctAnswer": "3",
      "messageForCorrectAnswer": "Correct.",
      "messageForIncorrectAnswer": "Incorrect.",
      "explanation": "Node.js uses asynchronous non-blocking I/O for high performance.",
      "point": "2"
    },
    {
      "question": "Which object handles events in Node.js?",
      "questionType": "text",
      "answerSelectionType": "single",
      "answers": [
        "EventCenter",
        "EventEmitter",
        "EventObject",
        "EmitterEngine"
      ],
      "correctAnswer": "2",
      "messageForCorrectAnswer": "Correct.",
      "messageForIncorrectAnswer": "Incorrect.",
      "explanation": "EventEmitter handles events in Node.js.",
      "point": "2"
    },
    {
      "question": "Streams in Node.js can be:",
      "questionType": "text",
      "answerSelectionType": "multiple",
      "answers": [
        "Readable",
        "Writable",
        "Duplex",
        "Transform"
      ],
      "correctAnswer": [1, 2, 3, 4],
      "messageForCorrectAnswer": "Correct.",
      "messageForIncorrectAnswer": "Incorrect.",
      "explanation": "Streams in Node.js can be readable, writable, duplex, or transform streams.",
      "point": "2"
    },
    {
      "question": "Which method is used to read a file in Node.js asynchronously?",
      "questionType": "text",
      "answerSelectionType": "single",
      "answers": [
        "fs.read()",
        "fs.readFile()",
        "fs.readFileAsync()",
        "fs.getFile()"
      ],
      "correctAnswer": "2",
      "messageForCorrectAnswer": "Correct.",
      "messageForIncorrectAnswer": "Incorrect.",
      "explanation": "fs.readFile() is the asynchronous method to read files in Node.js.",
      "point": "2"
    },
    {
      "question": "Buffers in Node.js are used for:",
      "questionType": "text",
      "answerSelectionType": "single",
      "answers": [
        "Storing binary data",
        "Rendering HTML",
        "Storing JSON objects",
        "Database transactions"
      ],
      "correctAnswer": "1",
      "messageForCorrectAnswer": "Correct.",
      "messageForIncorrectAnswer": "Incorrect.",
      "explanation": "Buffers are used to handle binary data directly in Node.js.",
      "point": "2"
    },
    {
      "question": "Which of the following can create a buffer?",
      "questionType": "text",
      "answerSelectionType": "multiple",
      "answers": [
        "Buffer.from()",
        "Buffer.alloc()",
        "Buffer.write()",
        "Buffer.make()"
      ],
      "correctAnswer": [1, 2],
      "messageForCorrectAnswer": "Correct.",
      "messageForIncorrectAnswer": "Incorrect.",
      "explanation": "Buffer.from() and Buffer.alloc() are standard ways to create buffers in Node.js.",
      "point": "2"
    },
    {
      "question": "Which command installs a Node.js package?",
      "questionType": "text",
      "answerSelectionType": "single",
      "answers": [
        "npm install packageName",
        "node install packageName",
        "npm get packageName",
        "node get packageName"
      ],
      "correctAnswer": "1",
      "messageForCorrectAnswer": "Correct.",
      "messageForIncorrectAnswer": "Incorrect.",
      "explanation": "npm install packageName installs a package in Node.js.",
      "point": "2"
    },
    {
      "question": "Which command installs a package globally?",
      "questionType": "text",
      "answerSelectionType": "single",
      "answers": [
        "npm install -g packageName",
        "npm global packageName",
        "node install -g packageName",
        "npm get -g packageName"
      ],
      "correctAnswer": "1",
      "messageForCorrectAnswer": "Correct.",
      "messageForIncorrectAnswer": "Incorrect.",
      "explanation": "npm install -g packageName installs a package globally.",
      "point": "2"
    },
    {
      "question": "Which file lists all installed dependencies?",
      "questionType": "text",
      "answerSelectionType": "single",
      "answers": [
        "dependencies.json",
        "node_modules.json",
        "package.json",
        "modules.json"
      ],
      "correctAnswer": "3",
      "messageForCorrectAnswer": "Correct.",
      "messageForIncorrectAnswer": "Incorrect.",
      "explanation": "package.json lists all dependencies of a Node.js project.",
      "point": "2"
    },
    {
      "question": "What is middleware in Node.js?",
      "questionType": "text",
      "answerSelectionType": "single",
      "answers": [
        "A function that handles requests",
        "A security layer",
        "A database engine",
        "An event listener"
      ],
      "correctAnswer": "1",
      "messageForCorrectAnswer": "Correct.",
      "messageForIncorrectAnswer": "Incorrect.",
      "explanation": "Middleware in Node.js/Express handles requests, responses, and next function execution.",
      "point": "2"
    },
    {
      "question": "Which framework is built on top of Node.js?",
      "questionType": "text",
      "answerSelectionType": "single",
      "answers": [
        "React",
        "Angular",
        "Express.js",
        "Vue.js"
      ],
      "correctAnswer": "3",
      "messageForCorrectAnswer": "Correct.",
      "messageForIncorrectAnswer": "Incorrect.",
      "explanation": "Express.js is a Node.js web framework for building APIs and servers.",
      "point": "2"
    },
    {
      "question": "Express.js is used for:",
      "questionType": "text",
      "answerSelectionType": "multiple",
      "answers": [
        "Creating APIs",
        "Routing",
        "Middleware integration",
        "Database storage"
      ],
      "correctAnswer": [1, 2, 3],
      "messageForCorrectAnswer": "Correct.",
      "messageForIncorrectAnswer": "Incorrect.",
      "explanation": "Express.js handles routing, middleware, and API creation but not direct database storage.",
      "point": "2"
    },
    {
      "question": "Which method defines a GET route in Express?",
      "questionType": "text",
      "answerSelectionType": "single",
      "answers": [
        "app.route('/get')",
        "app.get('/path')",
        "route.get('/path')",
        "express.get('/path')"
      ],
      "correctAnswer": "2",
      "messageForCorrectAnswer": "Correct.",
      "messageForIncorrectAnswer": "Incorrect.",
      "explanation": "app.get('/path') defines a GET route in Express.",
      "point": "2"
    },
    {
      "question": "Which method starts an Express server?",
      "questionType": "text",
      "answerSelectionType": "single",
      "answers": [
        "app.begin()",
        "app.open()",
        "app.start()",
        "app.listen()"
      ],
      "correctAnswer": "4",
      "messageForCorrectAnswer": "Correct.",
      "messageForIncorrectAnswer": "Incorrect.",
      "explanation": "app.listen() starts an Express server on the specified port.",
      "point": "2"
    },
    {
      "question": "Node.js event loop handles:",
      "questionType": "text",
      "answerSelectionType": "multiple",
      "answers": [
        "Timers",
        "I/O callbacks",
        "Promises",
        "Blocking loops"
      ],
      "correctAnswer": [1, 2, 3],
      "messageForCorrectAnswer": "Correct.",
      "messageForIncorrectAnswer": "Incorrect.",
      "explanation": "The event loop handles timers, I/O callbacks, and promise resolutions but not blocking loops.",
      "point": "2"
    },
    {
      "question": "Which global object represents the current file?",
      "questionType": "text",
      "answerSelectionType": "single",
      "answers": [
        "__dirname",
        "__filename",
        "filename",
        "_file"
      ],
      "correctAnswer": "2",
      "messageForCorrectAnswer": "Correct.",
      "messageForIncorrectAnswer": "Incorrect.",
      "explanation": "__filename represents the full path of the current file.",
      "point": "2"
    },
    {
      "question": "Which object represents the directory of the current file?",
      "questionType": "text",
      "answerSelectionType": "single",
      "answers": [
        "__dir",
        "_folder",
        "__dirname",
        "currentDir"
      ],
      "correctAnswer": "3",
      "messageForCorrectAnswer": "Correct.",
      "messageForIncorrectAnswer": "Incorrect.",
      "explanation": "__dirname returns the directory path of the current file.",
      "point": "2"
    },
    {
      "question": "Which function executes code after a delay?",
      "questionType": "text",
      "answerSelectionType": "single",
      "answers": [
        "wait()",
        "setTimeout()",
        "delay()",
        "after()"
      ],
      "correctAnswer": "2",
      "messageForCorrectAnswer": "Correct.",
      "messageForIncorrectAnswer": "Incorrect.",
      "explanation": "setTimeout() executes a function after a specified delay.",
      "point": "2"
    },
    {
      "question": "Which function repeats a task at intervals?",
      "questionType": "text",
      "answerSelectionType": "single",
      "answers": [
        "repeat()",
        "setInterval()",
        "loopEvery()",
        "intervalRun()"
      ],
      "correctAnswer": "2",
      "messageForCorrectAnswer": "Correct.",
      "messageForIncorrectAnswer": "Incorrect.",
      "explanation": "setInterval() executes a function repeatedly at specified intervals.",
      "point": "2"
    },
    {
      "question": "Which module is used for creating child processes?",
      "questionType": "text",
      "answerSelectionType": "single",
      "answers": [
        "child_process",
        "process",
        "cluster",
        "fork"
      ],
      "correctAnswer": "1",
      "messageForCorrectAnswer": "Correct.",
      "messageForIncorrectAnswer": "Incorrect.",
      "explanation": "The child_process module allows spawning child processes in Node.js.",
      "point": "2"
    },
    {
      "question": "Which global object provides process information?",
      "questionType": "text",
      "answerSelectionType": "single",
      "answers": [
        "process",
        "system",
        "os",
        "env"
      ],
      "correctAnswer": "1",
      "messageForCorrectAnswer": "Correct.",
      "messageForIncorrectAnswer": "Incorrect.",
      "explanation": "process object provides information and control over the current Node.js process.",
      "point": "2"
    },
    {
      "question": "Which module provides OS-level utilities?",
      "questionType": "text",
      "answerSelectionType": "single",
      "answers": [
        "system",
        "os",
        "process",
        "util"
      ],
      "correctAnswer": "2",
      "messageForCorrectAnswer": "Correct.",
      "messageForIncorrectAnswer": "Incorrect.",
      "explanation": "The 'os' module provides OS-related utility methods and properties.",
      "point": "2"
    },
    {
      "question": "Which method converts a buffer to a string?",
      "questionType": "text",
      "answerSelectionType": "single",
      "answers": [
        "buffer.toString()",
        "buffer.convert()",
        "buffer.stringify()",
        "buffer.encode()"
      ],
      "correctAnswer": "1",
      "messageForCorrectAnswer": "Correct.",
      "messageForIncorrectAnswer": "Incorrect.",
      "explanation": "buffer.toString() converts the contents of a buffer to a string.",
      "point": "2"
    },
    {
      "question": "Which method writes data to a file asynchronously?",
      "questionType": "text",
      "answerSelectionType": "single",
      "answers": [
        "fs.write()",
        "fs.writeFile()",
        "fs.writeAsync()",
        "fs.saveFile()"
      ],
      "correctAnswer": "2",
      "messageForCorrectAnswer": "Correct.",
      "messageForIncorrectAnswer": "Incorrect.",
      "explanation": "fs.writeFile() writes data to a file asynchronously in Node.js.",
      "point": "2"
    },
    {
      "question": "Which module helps with query strings in URLs?",
      "questionType": "text",
      "answerSelectionType": "single",
      "answers": [
        "url",
        "querystring",
        "qs",
        "uri"
      ],
      "correctAnswer": "2",
      "messageForCorrectAnswer": "Correct.",
      "messageForIncorrectAnswer": "Incorrect.",
      "explanation": "The querystring module helps parse and format URL query strings.",
      "point": "2"
    },
    {
      "question": "Which method parses a JSON string into an object?",
      "questionType": "text",
      "answerSelectionType": "single",
      "answers": [
        "JSON.stringify()",
        "JSON.parse()",
        "JSON.objectify()",
        "JSON.convert()"
      ],
      "correctAnswer": "2",
      "messageForCorrectAnswer": "Correct.",
      "messageForIncorrectAnswer": "Incorrect.",
      "explanation": "JSON.parse() converts a JSON string into a JavaScript object.",
      "point": "2"
    },
    {
      "question": "Which module is used for cryptography?",
      "questionType": "text",
      "answerSelectionType": "single",
      "answers": [
        "crypto",
        "security",
        "encrypt",
        "hash"
      ],
      "correctAnswer": "1",
      "messageForCorrectAnswer": "Correct.",
      "messageForIncorrectAnswer": "Incorrect.",
      "explanation": "The 'crypto' module provides cryptographic functionalities in Node.js.",
      "point": "2"
    },
    {
      "question": "Which module provides utilities for debugging?",
      "questionType": "text",
      "answerSelectionType": "single",
      "answers": [
        "util",
        "debug",
        "console",
        "inspect"
      ],
      "correctAnswer": "1",
      "messageForCorrectAnswer": "Correct.",
      "messageForIncorrectAnswer": "Incorrect.",
      "explanation": "The 'util' module provides utility functions including debugging helpers.",
      "point": "2"
    },
    {
      "question": "Which module helps in creating TCP servers?",
      "questionType": "text",
      "answerSelectionType": "single",
      "answers": [
        "http",
        "net",
        "tcp",
        "socket"
      ],
      "correctAnswer": "2",
      "messageForCorrectAnswer": "Correct.",
      "messageForIncorrectAnswer": "Incorrect.",
      "explanation": "The 'net' module allows creating TCP and IPC servers in Node.js.",
      "point": "2"
    },
    {
      "question": "Which command checks Node.js version?",
      "questionType": "text",
      "answerSelectionType": "single",
      "answers": [
        "node --version",
        "node -v",
        "Both 1 and 2",
        "node version"
      ],
      "correctAnswer": "3",
      "messageForCorrectAnswer": "Correct.",
      "messageForIncorrectAnswer": "Incorrect.",
      "explanation": "Both 'node --version' and 'node -v' display the Node.js version.",
      "point": "2"
    },
    {
      "question": "Which method stops a timer in Node.js?",
      "questionType": "text",
      "answerSelectionType": "single",
      "answers": [
        "clearTimer()",
        "clearTimeout()",
        "stopTimer()",
        "cancelTimer()"
      ],
      "correctAnswer": "2",
      "messageForCorrectAnswer": "Correct.",
      "messageForIncorrectAnswer": "Incorrect.",
      "explanation": "clearTimeout() stops a timer set with setTimeout().",
      "point": "2"
    },
    {
      "question": "Which method stops an interval timer?",
      "questionType": "text",
      "answerSelectionType": "single",
      "answers": [
        "clearInterval()",
        "stopInterval()",
        "cancelInterval()",
        "intervalClear()"
      ],
      "correctAnswer": "1",
      "messageForCorrectAnswer": "Correct.",
      "messageForIncorrectAnswer": "Incorrect.",
      "explanation": "clearInterval() stops an interval timer set with setInterval().",
      "point": "2"
    },
    {
      "question": "Which of the following are core features of Node.js?",
      "questionType": "text",
      "answerSelectionType": "multiple",
      "answers": [
        "Non-blocking I/O",
        "Event-driven architecture",
        "Single-threaded",
        "Built-in ORM"
      ],
      "correctAnswer": [1, 2, 3],
      "messageForCorrectAnswer": "Correct.",
      "messageForIncorrectAnswer": "Incorrect.",
      "explanation": "Node.js is non-blocking, event-driven, and single-threaded; it does not have a built-in ORM.",
      "point": "2"
    },
    {
      "question": "Which object can be used to pass command line arguments?",
      "questionType": "text",
      "answerSelectionType": "single",
      "answers": [
        "process.args",
        "process.argv",
        "process.parameters",
        "process.input"
      ],
      "correctAnswer": "2",
      "messageForCorrectAnswer": "Correct.",
      "messageForIncorrectAnswer": "Incorrect.",
      "explanation": "process.argv contains command line arguments passed to Node.js.",
      "point": "2"
    },
    {
      "question": "Which event is emitted when a readable stream ends?",
      "questionType": "text",
      "answerSelectionType": "single",
      "answers": [
        "finish",
        "end",
        "close",
        "done"
      ],
      "correctAnswer": "2",
      "messageForCorrectAnswer": "Correct.",
      "messageForIncorrectAnswer": "Incorrect.",
      "explanation": "The 'end' event is emitted when a readable stream has no more data.",
      "point": "2"
    },
    {
      "question": "Which method pipes data from one stream to another?",
      "questionType": "text",
      "answerSelectionType": "single",
      "answers": [
        "stream.transfer()",
        "stream.pipe()",
        "stream.connect()",
        "stream.forward()"
      ],
      "correctAnswer": "2",
      "messageForCorrectAnswer": "Correct.",
      "messageForIncorrectAnswer": "Incorrect.",
      "explanation": "stream.pipe() pipes data from one stream to another.",
      "point": "2"
    },
    {
      "question": "Which module provides utilities for formatting and inspecting objects?",
      "questionType": "text",
      "answerSelectionType": "single",
      "answers": [
        "util",
        "format",
        "inspect",
        "debug"
      ],
      "correctAnswer": "1",
      "messageForCorrectAnswer": "Correct.",
      "messageForIncorrectAnswer": "Incorrect.",
      "explanation": "The 'util' module includes utilities for formatting, inspecting objects, and debugging.",
      "point": "2"
    },
    {
      "question": "Which module is used to compress or decompress data?",
      "questionType": "text",
      "answerSelectionType": "single",
      "answers": [
        "zlib",
        "gzip",
        "compress",
        "buffer"
      ],
      "correctAnswer": "1",
      "messageForCorrectAnswer": "Correct.",
      "messageForIncorrectAnswer": "Incorrect.",
      "explanation": "The 'zlib' module provides compression (gzip/deflate) functionalities.",
      "point": "2"
    },
    {
      "question": "Which method converts an object to a JSON string?",
      "questionType": "text",
      "answerSelectionType": "single",
      "answers": [
        "JSON.parse()",
        "JSON.stringify()",
        "JSON.objectify()",
        "JSON.toString()"
      ],
      "correctAnswer": "2",
      "messageForCorrectAnswer": "Correct.",
      "messageForIncorrectAnswer": "Incorrect.",
      "explanation": "JSON.stringify() converts a JavaScript object into a JSON string.",
      "point": "2"
    }
  ]
};